<h1 *ngIf="levelNumeric === 1"
	[ngClass]="getClass()"
	[attr.data-t-decorator]="decorator"
	[innerHTML]="text"></h1>
<h2 *ngIf="levelNumeric === 2"
	[ngClass]="getClass()"
	[attr.data-t-decorator]="decorator"
	[innerHTML]="text"></h2>
<h3 *ngIf="levelNumeric === 3"
	[ngClass]="getClass()"
	[attr.data-t-decorator]="decorator"
	[innerHTML]="text"></h3>
<h4 *ngIf="levelNumeric === 4"
	[ngClass]="getClass()"
	[attr.data-t-decorator]="decorator"
	[innerHTML]="text"></h4>
<h5 *ngIf="levelNumeric === 5"
	[ngClass]="getClass()"
	[attr.data-t-decorator]="decorator"
	[innerHTML]="text"></h5>
<h6 *ngIf="levelNumeric === 6"
	[ngClass]="getClass()"
	[attr.data-t-decorator]="decorator"
	[innerHTML]="text"></h6>
